/** Shared helpers for building loyalty actions (stamp / redeem) against the POS + backend. */
import { config } from '../config/env'
import { getLightspeedApi } from '../lightspeed/pos-api'
import type { PosAccount } from '../lightspeed/types'
import type { CustomerResponse, PendingRequest } from './types'

export function buildPayload(
  account: PosAccount,
  data: CustomerResponse,
  extra: Pick<PendingRequest, 'stamp_amount' | 'is_redemption' | 'reward_id' | 'cancel'>,
): PendingRequest {
  const ctx = getLightspeedApi().getContext()
  return {
    webext_uuid: config.webextUuid,
    ls_account_id: ctx?.businessId ?? '',
    account_reference: account.number ?? '',
    consumer_id: data.consumer.consumer_id,
    await_payment: true, // M2: buffer the intent; the webhook commits at confirmed payment.
    ...extra,
  }
}
